import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';

const { Storage } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  async setString(key: string, value: string) {
    await Storage.set({ key, value });
  }

  async getString(key: string): Promise<{ value: any }> {
    return (await Storage.get({ key }));
  }

  async setObject(key: string, value: any) {
    await Storage.set({ key, value: JSON.stringify(value) });
  }

  async getObject(key: string): Promise<{ value: any }> {
    const ret = await Storage.get({ key });
    return JSON.parse(ret.value);
  }


  async removeItem(key: string) {
    await Storage.remove({ key });
  }

  async clear() {
    await Storage.clear();
  }

  async incrementClientActivity(clientId: any, field: string | string[]): Promise<void> {
    const fields = (Array.isArray(field) ? field : [field]).filter(name => !!name);
    if (clientId == null || clientId === '' || fields.length === 0) {
      return;
    }
    const stored = await this.getObject('clients_difritz');
    if (!Array.isArray(stored)) {
      return;
    }
    const clients = stored.map((client) => {
      if (!client || client.id != clientId) {
        return client;
      }
      const next = {...client};
      fields.forEach((name) => {
        next[name] = (Number(next[name]) || 0) + 1;
      });
      return next;
    });
    await this.setObject('clients_difritz', clients);
  }
}